import "./App.css";
import Login from "./pages/Login";
import { Routes, Route, Navigate } from "react-router-dom";
import Unprotected from "./components/Unprotected";
import Protected from "./components/Protected";
import HomeRoute from "./HomeRoute";

function App() {
  return <div className="body-container">
          <Routes>
            <Route path="/login" element={<Unprotected><Login/></Unprotected>} />
            <Route path="dashboard/*" element={<Protected><HomeRoute /></Protected>} />
            <Route path="*" element={<Navigate to={'/login'} replace />}/>
        </Routes>  
    </div>
}

export default App;
